// extracted by mini-css-extract-plugin
export default {"balance":"styles_balance__zhAWz","pp":"styles_pp__ri41c"};